module.exports = __webpack_public_path__ + "static/slack-connect-project-be2b53570489af289eb299124cc17e4c.png";